{
  "items": [
    {
      "fileName": "GENERIC-NatureWater-01.mp4",
      "description": "The video shows an aerial view from above a thick layer of clouds at sunset or sunrise. The clouds are dense, white, and gray, with soft, billowing, cotton like textures filling the lower two thirds of the frame. The sun is positioned low on the horizon, partially hidden behind a cluster of clouds, creating a bright yellow, gold glow that radiates outward and illuminates the undersides of scattered clouds in the upper portion of the frame with pink, orange, and red tones. The sky above the cloud layer is a light blue, pale blue color, transitioning to soft pastel hues near the horizon. The lighting is bright and warm at the horizon, transitioning to cooler, softer tones higher in the sky, consistent with golden hour lighting during sunset or sunrise. The color palette is warm and vibrant near the horizon, dominated by gold, orange, pink, and red tones, transitioning to cool blue and gray tones in the upper sky and cloud layer. The composition is a wide, expansive aerial shot, with the horizon line positioned in the lower third of the frame and the sky filling the upper two thirds. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a wide depth of field and dramatic, atmospheric lighting.",
      "keyElements": ["clouds", "sun", "horizon", "sky", "lighting"],
      "attributes": [
        "dramatic",
        "atmospheric",
        "peaceful",
        "serene",
        "aerial",
        "wide shot",
        "golden hour",
        "sunset",
        "sunrise",
        "warm lighting",
        "natural light",
        "warm tone",
        "cool tone",
        "nature",
        "travel",
        "sky",
        "clouds",
        "sun",
        "gold",
        "orange",
        "pink",
        "blue",
        "horizon",
        "above clouds"
      ]
    },
    {
      "fileName": "GENERIC-NatureWater-02.mp4",
      "description": "The video shows an aerial view flying directly through a dense layer of billowing clouds. The clouds are thick, soft, and voluminous, filling almost the entire frame with rolling, cotton like formations. The clouds are illuminated with a soft pink, lavender, and peach colored glow, consistent with sunset or sunrise lighting, with brighter golden light visible in gaps between the cloud formations near the horizon line in the upper portion of the frame. The color palette is soft and pastel, dominated by lavender, pink, peach, and soft gold tones, with darker gray shadow areas within the deeper folds of the clouds. The lighting is soft and diffused, coming from a low sun angle, creating gentle highlights on the cloud tops and softer, shadowed tones within the cloud formations. The composition is a wide, immersive aerial shot, with clouds filling the entire frame and a small glimpse of a hazy horizon visible in the upper background. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a dreamy, atmospheric look and a wide depth of field.",
      "keyElements": ["clouds", "horizon", "lighting"],
      "attributes": [
        "dreamy",
        "atmospheric",
        "peaceful",
        "serene",
        "aerial",
        "wide shot",
        "sunset",
        "sunrise",
        "soft lighting",
        "natural light",
        "pastel tone",
        "warm tone",
        "nature",
        "travel",
        "clouds",
        "lavender",
        "pink",
        "peach",
        "gold",
        "sky",
        "immersive"
      ]
    },
    {
      "fileName": "GENERIC-NatureWater-03.mp4",
      "description": "The video shows a close up view of the surface of open ocean water, with rolling waves and ripples moving across the frame. The water is a deep blue, navy colored tone in the shadowed areas, transitioning to a bright, warm gold and amber color where sunlight reflects off the crests of the waves in the lower right portion of the frame. The texture of the water is textured and choppy, showing small ripples and foam along the wave crests. The lighting is bright and warm where the sunlight hits the water directly, creating sparkling, glowing highlights, while the rest of the water remains in cooler, shadowed blue tones. The color palette contrasts warm and cool tones, dominated by navy blue, teal, and gold tones. The composition is a close up, closeup, high angle framing, looking down at the water's surface, with the frame filled entirely by the textured water. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a shallow depth of field and dramatic lighting contrast between warm and cool tones.",
      "keyElements": [
        "waves",
        "ripples",
        "foam",
        "sunlight reflection",
        "lighting"
      ],
      "attributes": [
        "dramatic",
        "peaceful",
        "candid",
        "close up",
        "closeup",
        "high angle",
        "shallow depth of field",
        "warm lighting",
        "natural light",
        "warm tone",
        "cool tone",
        "contrast",
        "nature",
        "ocean",
        "sea",
        "water",
        "waves",
        "navy blue",
        "teal",
        "gold",
        "amber",
        "ripples",
        "sparkle"
      ]
    },
    {
      "fileName": "GENERIC-NatureWater-04.mp4",
      "description": "The video shows a close up view of raindrops streaming down the outside of a glass window pane. Numerous individual water droplets of varying sizes cling to the glass, while thin, winding streaks of water trail downward from some droplets, forming vertical rivulets. The background visible through the glass is blurred and out of focus, showing a soft gradient from a light beige, cream colored glow in the upper portion of the frame to a dark, near black tone in the lower and side portions of the frame. The lighting is soft and diffused, consistent with an overcast or dim ambient light source behind the glass, creating a moody, atmospheric contrast between the bright upper area and the dark surroundings. The color palette is monochromatic and moody, dominated by black, gray, and cream tones. The composition is an extreme close up, closeup, full frame shot, with raindrops and water streaks covering the entire visible glass surface. The visual style is photographic, realistic, and resembles a moody or atmospheric weather style stock video with a shallow depth of field and dramatic, high contrast lighting.",
      "keyElements": [
        "glass window",
        "raindrops",
        "water streaks",
        "background glow",
        "lighting"
      ],
      "attributes": [
        "moody",
        "atmospheric",
        "dramatic",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "high contrast",
        "dim lighting",
        "monochromatic",
        "dark tone",
        "weather",
        "rain",
        "nature",
        "window",
        "glass",
        "raindrops",
        "water",
        "streaks",
        "black",
        "gray",
        "cream"
      ]
    },
    {
      "fileName": "GENERIC-NatureWater-05.mp4",
      "description": "The video shows a dramatic sky filled with dense, dark storm clouds, viewed from below looking upward. The clouds are thick and voluminous, in varying shades of dark gray, blue gray, and white, with a small patch of deep blue sky visible breaking through the clouds in the upper portion of the frame. The clouds appear turbulent and heavy, suggesting an approaching storm, with darker, denser cloud formations in the lower portion of the frame and lighter, brighter cloud edges catching diffused sunlight in the middle and upper portions. The lighting is soft and diffused, filtering through the thick cloud cover, creating subtle highlights on the cloud edges while the overall scene remains moody and subdued. The color palette is cool and muted, dominated by gray, blue gray, and white tones, with a small patch of deep blue visible through the clouds. The composition is a wide, expansive shot, looking directly upward, with clouds filling the entire frame. The visual style is photographic, realistic, and resembles a weather or nature style stock video with a wide depth of field and a moody, dramatic atmosphere.",
      "keyElements": ["storm clouds", "sky", "lighting"],
      "attributes": [
        "dramatic",
        "moody",
        "turbulent",
        "wide shot",
        "low angle",
        "diffused lighting",
        "natural light",
        "cool tone",
        "muted tone",
        "weather",
        "storm",
        "nature",
        "clouds",
        "gray",
        "blue gray",
        "white",
        "blue sky",
        "atmospheric"
      ]
    },
    {
      "fileName": "GENERIC-NatureWater-06.mp4",
      "description": "The video shows a top down view of calm, shallow water with a pale, light turquoise, blue green color. The water's surface displays subtle ripples and concentric circular rings expanding outward from a central point, suggesting something recently disturbed the water's surface. A small, dark, indistinct shape or shadow is visible beneath the surface near the center of the ripples. The lighting is bright and even, consistent with overhead natural daylight, creating a soft, glowing, uniform illumination across the water's surface with minimal shadow. The color palette is soft and pale, dominated by light turquoise, pale blue, and white tones. The composition is a direct overhead, top down shot, with the rippling water filling the entire frame. The visual style is photographic, realistic, and resembles a nature or wellness style stock video with a calm, serene, minimal aesthetic and a wide depth of field.",
      "keyElements": ["water surface", "ripples", "shadow shape", "lighting"],
      "attributes": [
        "calm",
        "peaceful",
        "serene",
        "minimal",
        "overhead",
        "top down",
        "bright lighting",
        "natural light",
        "pale tone",
        "soft tone",
        "nature",
        "wellness",
        "water",
        "ripples",
        "turquoise",
        "pale blue",
        "white",
        "shallow water"
      ]
    },
    {
      "fileName": "GENERIC-NatureWater-07.mp4",
      "description": "The video shows an aerial drone view looking directly down at ocean water with active waves and white foam. The water is a rich teal, turquoise color, with multiple wave crests breaking and creating intricate patterns of white sea foam and bubbles that spread across the dark blue green water in swirling, lace like formations. The composition shows varying depths of water color, from lighter, brighter teal in areas of foam and turbulence to darker, deeper navy blue in calmer patches. The lighting is bright and even, consistent with overhead daylight, creating natural highlights on the wave crests and foam. The color palette is cool and vibrant, dominated by teal, turquoise, navy blue, and white tones. The composition is a direct overhead, top down aerial shot, with the textured, foamy ocean water filling the entire frame. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a wide depth of field and a dynamic, textured aesthetic.",
      "keyElements": ["ocean waves", "foam", "water texture", "lighting"],
      "attributes": [
        "dynamic",
        "textured",
        "aerial",
        "overhead",
        "top down",
        "bright lighting",
        "natural light",
        "cool tone",
        "vibrant",
        "nature",
        "travel",
        "ocean",
        "sea",
        "waves",
        "foam",
        "teal",
        "turquoise",
        "navy blue",
        "white",
        "water"
      ]
    }
  ]
}
